import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/name.png";
import linkedin from "../assets/img/linkedin.svg";
import twitter from "../assets/img/twitter.svg";
import github from "../assets/img/github.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img className="logos" src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon margin">
              <a href="https://www.linkedin.com/in/akuu-khan/" target="_blank" rel="noreferrer"><img src={linkedin} alt="Icon" /></a>
              <a href="https://twitter.com/aaku_mdakbar" target="_blank" rel="noreferrer"><img src={twitter} alt="Icon" /></a>
              <a href="https://github.com/aakbarkhan" target="_blank" rel="noreferrer"><img src={github} alt="Icon" /></a>
            </div>
            <p>Copyright 2022. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}